export default __webpack_public_path__ + "959c27b14cbad4f558bef8651012d2ea.svg";